import { createAsyncAction } from 'typesafe-actions';

import { FailureActionPayload } from '../errors/types';
import { ToggleResourceFavoriteParams, ToggleResourceFavoriteResult } from './types';

export const toggleResourceFavorite = createAsyncAction(
  'TOGGLE_RESOURCE_FAVORITE_REQUEST',
  'TOGGLE_RESOURCE_FAVORITE_SUCCESS',
  'TOGGLE_RESOURCE_FAVORITE_FAILURE',
)<ToggleResourceFavoriteParams, ToggleResourceFavoriteResult, FailureActionPayload & ToggleResourceFavoriteResult>();
